import { defineStyle, defineStyleConfig } from "@chakra-ui/react";

const baseStyle = defineStyle({
  fontFamily: "heading",
  fontWeight: "light",
  textTransform: "uppercase",
});

const variants = {
  display: defineStyle({
    fontSize: "display",
    lineHeight: "display",
    letterSpacing: "display",
  }),
  section: defineStyle({
    fontSize: "h2",
    lineHeight: "section",
    letterSpacing: "section",
    textWrap: "balance",
  }),
  card: defineStyle({
    fontSize: "cardTitle",
    lineHeight: "card",
    textWrap: "balance",
  }),
  step: defineStyle({
    fontSize: "h3",
    lineHeight: 0.9,
  }),
};

export const Heading = defineStyleConfig({
  baseStyle,
  variants,
  defaultProps: { variant: "section" },
});
